export type LatestRequest = {
  signal: AbortSignal;
  isCurrent(): boolean;
  finish(): void;
};

/** Coordinates cancellable work so only the newest request can publish. */
export function createLatestRequestCoordinator() {
  let nextId = 0;
  let active: { controller: AbortController; id: number } | undefined;

  return {
    begin(): LatestRequest {
      active?.controller.abort();
      const current = { controller: new AbortController(), id: ++nextId };
      active = current;
      return {
        signal: current.controller.signal,
        isCurrent: () => active?.id === current.id,
        finish: () => {
          if (active?.id === current.id) active = undefined;
        },
      };
    },
    cancel() {
      active?.controller.abort();
      active = undefined;
      nextId += 1;
    },
  };
}
